<template>
  <ul class="sidebar__benefits">
    <li class="sidebar__benefits-item">
      <img alt="" class="sidebar__benefits-icon" src="/shop/images/truck-tick.svg">
      <div class="sidebar__benefits-text">{{ in18['page_benefits_delivery'] }}</div>
    </li>
    <li class="sidebar__benefits-item">
      <img alt="" class="sidebar__benefits-icon" src="/shop/images/empty-wallet-tick.svg">
      <div class="sidebar__benefits-text">{{ in18['page_benefits_payment'] }}</div>
    </li>
  </ul>

  <div class="sidebar__contact">
    <div class="sidebar__content_desktop">
      <template v-if="catalog_banner && catalog_banner.desktop_image">
      <a v-if="catalog_banner.link" :href="catalog_banner.link">
        <picture>
          <source :srcset="catalog_banner.desktop_image.webp" type="image/webp">
          <img :alt="catalog_banner.title" class="img" :src="catalog_banner.desktop_image.source">
        </picture>
      </a>
      <template v-else>
        <picture>
          <source :srcset="catalog_banner.desktop_image.webp" type="image/webp">
          <img :alt="catalog_banner.title" class="img" :src="catalog_banner.desktop_image.source">
        </picture>
      </template>
    </template>
    </div>
    <div class="sidebar__content_mobile">
      <template v-if="catalog_banner && catalog_banner.mobile_image">
        <a v-if="catalog_banner.link" :href="catalog_banner.link">
          <picture>
            <source :srcset="catalog_banner.mobile_image.webp" type="image/webp">
            <img :alt="catalog_banner.title" class="img" :src="catalog_banner.mobile_image.source">
          </picture>
        </a>
        <template v-else>
          <picture>
            <source :srcset="catalog_banner.mobile_image.webp" type="image/webp">
            <img :alt="catalog_banner.title" class="img" :src="catalog_banner.mobile_image.source">
          </picture>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    in18:           Object,
    catalog_banner: Object,
  },
};
</script>
